<script setup>
import { useForm } from "@inertiajs/vue3";

import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VInputWithLabel from "@/Shared/Form/VInputWithLabel.vue";
import VAlert from "@/Shared/VAlert.vue";

import VModal from "@/Shared/VModal.vue";
import RoleRow from "./RoleRow.vue";
import { ref } from "vue";

const props = defineProps({
    type: String,
    role: Object,
    menulist: Array,

    urlSubmit: String,

    method: String,
});

const emits = defineEmits(["onSave", "onCancel"]);

const refModal = ref(null);

const title =
    props.type == "create" ? "Add User Access Role" : "Edit User Access Role";

const activePermission = props.role?.permissions.map((item) => item.id) ?? [];

const form = useForm({
    name: props.role?.name,
    selPermission: activePermission,
    _method: props.method,
});

const submit = () => {
    form.post(props.urlSubmit, {
        preserveScroll: true,
        forceFormData: true,
        onSuccess: () => {
            emits("onSave", form.value);
            refModal.value.closeModal();
        },
    });
};

const cancel = () => {
    emits("onCancel");
};
</script>

<template>
    <VModal ref="refModal" :title="title" size="modal-lg" @onClose="cancel">
        <template v-slot:body>
            <div class="m-3">
                <form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <VInputWithLabel
                                elId="name"
                                label="Name"
                                type="text"
                                :error="form.errors.name"
                                v-model:value="form.name"
                            />
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <caption class="d-none">
                                Table Menu Permission
                            </caption>
                            <thead>
                                <tr>
                                    <th>No.</th>
                                    <th>Menu</th>
                                    <th>Permission</th>
                                </tr>
                            </thead>
                            <tbody>
                                <RoleRow
                                    v-for="(menu, index) in menulist"
                                    :key="menu.id"
                                    :menu="menu"
                                    v-model:value="form.selPermission"
                                    parentIteration=""
                                    :index="index"
                                    :isHeader="true"
                                />
                            </tbody>
                        </table>
                    </div>
                </form>
            </div>
        </template>

        <template v-slot:footer>
            <div class="text-end">
                <VButtonSubmit
                    type="submit"
                    :isProcessing="form.processing"
                    @onCLickSubmit="submit"
                >
                    Submit
                </VButtonSubmit>
            </div>
        </template>
    </VModal>
</template>
